var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { axiosPrivate } from "../../api/axios";
import { SkipDayUpdateToasts } from "./skipDays-types";
/**
 *
 * @param date
 * @returns a moment normalized to utc
 */
export const normalizeDate = (date) => moment(date).utc();
/**
 * func to consistently format dates/maintain DRY
 * @param date
 * @returns a formatted date-string for display
 */
export const formatSkipDateDisplay = (date) => moment(date).utc().format("ddd L");
/**
 * func to consistently format weekday abbreviations/maintain DRY
 * @param date
 * @returns a formatted 3-letter weekday string for display
 */
export const formatSkipWeekday = (date) => moment(date).utc().format("ddd");
/**
 * func to consistently format calendar dates/maintain DRY
 * @param date
 * @returns a localized date string for display
 */
export const formatSkipDate = (date) => moment(date).utc().format("L");
/**
 * Function that is called when the SWR mutation is called
 * @param _key
 * @param date date to skip or unskip
 * @param skip whether or not the date is being skipped or unskipped
 * @returns
 */
export const updateSkipDay = (key, { arg }) => __awaiter(void 0, void 0, void 0, function* () {
    const { updates } = arg;
    const response = yield axiosPrivate.post("/Account/UpdateSkipDays", updates.map(({ date, skip }) => ({ customerDate: date, skip })));
    return response.data;
});
/**
 * Groups all skip days by month
 * @param skipDays
 * @returns
 */
export const groupSkipDaysByMonth = (skipDays) => {
    const grouped = [];
    skipDays === null || skipDays === void 0 ? void 0 : skipDays.forEach((skipDay) => {
        const month = moment(skipDay.customerDate).utc().month();
        const index = grouped.findIndex((m) => m.month === month);
        if (index !== -1) {
            grouped[index].days.push(skipDay);
        }
        else {
            grouped.push({ month, days: [skipDay] });
        }
    });
    return grouped;
};
/**
 *
 * @param date
 * @param skip
 * @param success
 * @param toast
 */
export const buildMutationToastStrings = (date, skip, success, toast) => {
    const formattedDisplayDate = formatSkipDateDisplay(date);
    let toastText = "";
    if (success) {
        toastText = skip
            ? `${SkipDayUpdateToasts.SKIP} ${formattedDisplayDate}!`
            : `${SkipDayUpdateToasts.UNSKIP} ${formattedDisplayDate}!`;
    }
    else {
        toastText = skip
            ? `${SkipDayUpdateToasts.ERROR_SKIP} ${formattedDisplayDate}!`
            : `${SkipDayUpdateToasts.ERROR_UNSKIP} ${formattedDisplayDate}!`;
    }
    toast.push(toastText, { variant: success ? "success" : "error" });
};
/**
 * Determines if a date is eligible for skip days interactions.
 * @param allSkipDays
 * @returns
 */
export const shouldDisableDate = (allSkipDays) => (date) => {
    const isEligibleSkipDay = allSkipDays === null || allSkipDays === void 0 ? void 0 : allSkipDays.find((skipDay) => date.isSame(skipDay.customerDate, "day"));
    return !isEligibleSkipDay;
};
